<div id="loading-container">
  @for (spinner of spinners; track spinner; let i = $index) {
    <div class="spinner-wrapper">
      <div class="spinner-grow text-primary" [style.width]="size + 'rem'" [style.height]="size + 'rem'" [style.animation-delay]="i*0.05 + 's'" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  }
</div>